<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div>推送消息编辑</div>
                </div>

                <div class="admin_main_block_right">
                    <div><el-button icon="el-icon-back" @click="$router.go(-1)">返回</el-button></div>
                </div>
            </div>

            <div class="admin_form_main">
                <el-form  label-width="100px" ref="info" :model="info">
                    <el-form-item label="预约会员" prop="F_VR_YUYHY" :rules="[{required:true,message:'预约会员不能为空',trigger: 'blur' }]"><el-input type="textarea" placeholder="请输入预约会员" maxlength="200" show-word-limit v-model="info.F_VR_YUYHY"></el-input></el-form-item>
                    <el-form-item label="预约人数" prop="F_VR_YUYRS" :rules="[{required:true,message:'预约人数不能为空',trigger: 'blur' }]"><el-input type="textarea" placeholder="请输入预约人数" maxlength="200" show-word-limit v-model="info.F_VR_YUYRS"></el-input></el-form-item>
                    <el-form-item label="预约项目" prop="F_VR_YUYXM" :rules="[{required:true,message:'预约项目不能为空',trigger: 'blur' }]"><el-input type="textarea" placeholder="请输入预约项目" maxlength="200" show-word-limit v-model="info.F_VR_YUYXM"></el-input></el-form-item>
                    <el-form-item label="预约到店时间" prop="F_VR_YUYDDSJ" :rules="[{required:true,message:'预约到店时间不能为空',trigger: 'blur' }]"><el-input type="textarea" placeholder="请输入预约到店时间" maxlength="200" show-word-limit v-model="info.F_VR_YUYDDSJ"></el-input></el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="submitForm('info')">提交</el-button>
                        <!-- <el-button @click="resetForm('info')">重置</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          edit_id:0,
          info:{
          },
          list:[],
          upload_headers:{},
      };
    },
    watch: {},
    computed: {},
    methods: {
        resetForm:function(e){
            this.$refs[e].resetFields();
        },
        submitForm:function(e){
            let _this = this;

            // 验证表单
            this.$refs[e].validate(function(res){
                if(res){
                    //  判断是Add 或者 Edit
                    let url = _this.$api.addXyxjxxts;
                    if(_this.edit_id>0){
                        url = _this.$api.editXyxjxxts+_this.edit_id;
                    }
                    // Http 请求
                    _this.$post(url,_this.info).then(function(res){
                        if(res.code == 200){
                            _this.$message.success("编辑成功");
                            _this.$router.go(-1);
                        }else{
                            _this.$message.error("编辑失败");
                        }
                    });
                }
            });
        },
        get_adv_info:function(){
            let _this = this;
            this.$get(this.$api.editXyxjxxts+this.edit_id).then(function(res){
                _this.info = res.data.xianslb;
                _this.list = res.data.zsls;
            })

        },

        selectChange:function(){
            this.$forceUpdate();
        },
        handleAvatarSuccess(res) {
            this.info.adv_image = res.data;
            this.$forceUpdate();
        },
    },
    created() {
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到

        if(!this.$isEmpty(this.$route.params.adv_position_id)){
            this.info.ap_id = this.$route.params.adv_position_id;
        }

        // 判断是否是编辑
        if(!this.$isEmpty(this.$route.params.id)){
            this.edit_id = this.$route.params.id;
        }

        if(this.edit_id>0){
            this.get_adv_info();
        }
        
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.line{text-align: center}
</style>